export const ROUTE_PATHS = {
  HOME: '/',
  ADMIN: '/admin',
  IDEA: '/idea',
  CMENTARZ: '/cmentarz',
  REZERWACJA: '/rezerwacja',
  KREATOR: '/kreator',
  REJESTRACJA: '/rejestracja',
  LOGOWANIE: '/logowanie',
  KONTO: '/konto',
  WERSJE: '/wersje',
  POLITYKA: '/polityka-prywatnosci',
  REGULAMIN: '/regulamin',
  AUTH_CALLBACK: '/auth/callback',
} as const;

export const APP_VERSION = '0.17.0-alpha' as const;
export const APP_STAGE   = 'alpha'        as const;

export const ADMIN_EMAILS = [
  'piotr@e-grob.pl',
  'arek@e-grob.pl',
  'adam@e-grob.pl',
  'biuro@e-grob.pl',
] as const;

export const ADMIN_PIN_HASH_KEY = 'egrob_admin_pin_verified';

export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return (ADMIN_EMAILS as readonly string[]).includes(email.toLowerCase().trim());
}

export interface GraveElement {
  id: string;
  type: 'cross' | 'flower' | 'candle' | 'frame' | 'plaque' | 'statue' | 'text' | 'photo';
  label: string;
  image?: string;
  imagePath?: string;
  x: number;
  y: number;
  width: number;
  height: number;
  zIndex: number;
  isPremium?: boolean;
  textContent?: string;
  fontSize?: number;
  color?: string;
}

export interface GraveTheme {
  id: string;
  name: string;
  bgColor: string;
  bgImage?: string;
  stoneColor: string;
  isPremium?: boolean;
  preview: string;
}

export interface GraveSkin {
  id: string;
  name: string;
  description: string;
  preview: string;
  isPremium?: boolean;
  themeId: string;
}

export const GRAVE_THEMES: GraveTheme[] = [
  { id: 'classic',  name: 'Klasyczny',    bgColor: '#1a1f2e', stoneColor: '#4a5568', isPremium: false, preview: '' },
  { id: 'marble',   name: 'Marmur',       bgColor: '#1e1e2e', stoneColor: '#e2e8f0', isPremium: false, preview: '' },
  { id: 'onyx',     name: 'Onyx',         bgColor: '#0d0d0d', stoneColor: '#1a1a2e', isPremium: true,  preview: '' },
  { id: 'granite',  name: 'Granit',       bgColor: '#161b22', stoneColor: '#8b7355', isPremium: false, preview: '' },
  { id: 'gold',     name: 'Złoto & Czerń',bgColor: '#0a0a0a', stoneColor: '#d4af37', isPremium: true,  preview: '' },
  { id: 'midnight', name: 'Północ',       bgColor: '#020817', stoneColor: '#1e3a5f', isPremium: true,  preview: '' },
];

export const GRAVE_SKINS: GraveSkin[] = [
  { id: 'minimal',   name: 'Minimalistyczny', description: 'Czysty, nowoczesny design',              themeId: 'classic',  isPremium: false, preview: '' },
  { id: 'orthodox',  name: 'Prawosławny',     description: 'Tradycyjne zdobienia wschodnie',         themeId: 'marble',   isPremium: false, preview: '' },
  { id: 'military',  name: 'Wojskowy',        description: 'Surowy, honorowy styl',                   themeId: 'granite',  isPremium: false, preview: '' },
  { id: 'baroque',   name: 'Barokowy',        description: 'Bogato zdobiony, majestatyczny',          themeId: 'gold',     isPremium: true,  preview: '' },
  { id: 'nature',    name: 'Natury',           description: 'Otoczony kwiatami i zielenią',            themeId: 'classic',  isPremium: true,  preview: '' },
  { id: 'celestial', name: 'Niebiański',      description: 'Gwiazdozbiory i złote akcenty',          themeId: 'midnight', isPremium: true,  preview: '' },
];

export interface DecoElement {
  id: string;
  category: 'cross' | 'flower' | 'candle' | 'frame' | 'plaque' | 'statue';
  label: string;
  emoji: string;
  imagePath?: string;
  isPremium?: boolean;
  defaultWidth: number;
  defaultHeight: number;
}

export const DECO_ELEMENTS: DecoElement[] = [
  { id: 'cross_gothic',  category: 'cross',  label: 'Krzyż gotycki',   emoji: '✝',  imagePath: '/images/element_cross_gothic_20260415_093530.png',   isPremium: false, defaultWidth: 80,  defaultHeight: 120 },
  { id: 'cross_simple',  category: 'cross',  label: 'Krzyż prosty',    emoji: '✚',  imagePath: '/images/element_cross_simple_20260415_093459.png',   isPremium: false, defaultWidth: 60,  defaultHeight: 90  },
  { id: 'cross_orthodox',category: 'cross',  label: 'Krzyż prawosławny',emoji: '☦', imagePath: undefined,                                             isPremium: true,  defaultWidth: 70,  defaultHeight: 110 },
  { id: 'wreath_roses',  category: 'flower', label: 'Wieniec róż',     emoji: '🌹',  imagePath: '/images/element_wreath_roses_20260415_093538.png',   isPremium: false, defaultWidth: 100, defaultHeight: 80  },
  { id: 'flower_lily',   category: 'flower', label: 'Lilie',           emoji: '🌷',  imagePath: undefined,                                             isPremium: false, defaultWidth: 60,  defaultHeight: 80  },
  { id: 'flower_prem',   category: 'flower', label: 'Bukiet premium',  emoji: '💐',  imagePath: undefined,                                             isPremium: true,  defaultWidth: 90,  defaultHeight: 90  },
  { id: 'candle_znicz',  category: 'candle', label: 'Znicz',           emoji: '🕯',  imagePath: '/images/element_candle_20260415_093445.png',          isPremium: false, defaultWidth: 40,  defaultHeight: 70  },
  { id: 'candle_pair',   category: 'candle', label: 'Dwa znicze',      emoji: '🕯',  imagePath: undefined,                                             isPremium: false, defaultWidth: 80,  defaultHeight: 70  },
  { id: 'plaque_gold',   category: 'plaque', label: 'Tablica złota',   emoji: '📜',  imagePath: '/images/element_plaque_gold_20260415_093543.png',     isPremium: false, defaultWidth: 140, defaultHeight: 70  },
  { id: 'plaque_marble', category: 'plaque', label: 'Tablica marmur',  emoji: '🪨',  imagePath: undefined,                                             isPremium: true,  defaultWidth: 140, defaultHeight: 70  },
  { id: 'angel',         category: 'statue', label: 'Anioł',           emoji: '👼',  imagePath: '/images/element_angel_20260415_093551.png',           isPremium: true,  defaultWidth: 90,  defaultHeight: 120 },
  { id: 'obelisk',       category: 'statue', label: 'Obelisk',         emoji: '🏛',  imagePath: '/images/element_obelisk_20260415_093513.png',         isPremium: true,  defaultWidth: 60,  defaultHeight: 130 },
];

export interface Plan {
  name: string;
  price: string;
  storage: string;
  features: string[];
  highlighted?: boolean;
  badge?: string;
}

export const PLANS: Plan[] = [
  {
    name: 'Free',
    price: '0 zł',
    storage: '500 MB',
    features: [
      'Podstawowe funkcje',
      'Publiczny profil',
      'Galeria zdjęć (do 50)',
      'Wsparcie email'
    ]
  },
  {
    name: 'Podstawowy',
    price: '19 zł/mies.',
    storage: '5 GB',
    features: [
      'Wszystko z Free',
      'Personalizacja grobu',
      'Galeria zdjęć (do 500)',
      'Wideo wspomnienia',
      'Priorytetowe wsparcie'
    ],
    highlighted: true,
    badge: 'Najpopularniejszy'
  },
  {
    name: 'Premium',
    price: '49 zł/mies.',
    storage: '50 GB',
    features: [
      'Wszystko z Podstawowego',
      'Pełna personalizacja',
      'Nieograniczona galeria',
      'Archiwum dokumentów',
      'Dedykowany opiekun',
      'Backup w chmurze'
    ]
  }
];

export interface HowItWorksStep {
  number: number;
  title: string;
  description: string;
}

export const HOW_IT_WORKS_STEPS: HowItWorksStep[] = [
  {
    number: 1,
    title: 'Wykup pole',
    description: 'Wybierz plan i zarezerwuj swoje cyfrowe miejsce pamięci. Proces trwa kilka minut.'
  },
  {
    number: 2,
    title: 'Zaprojektuj swój e-grób',
    description: 'Personalizuj wygląd, dodaj zdjęcia, wspomnienia i dokumenty. Twórz przestrzeń, która opowie Twoją historię.'
  },
  {
    number: 3,
    title: 'Zostaw coś bliskim',
    description: 'Twoje wspomnienia pozostaną dostępne dla przyszłych pokoleń. Cyfrowa pamięć, która przetrwa czas.'
  }
];